import Hero from "../../designSystem/Hero";
import SEO from "../../designSystem/SEO";
import PrimaryButtonSmall from "../../designSystem/buttons/PrimaryButtonSmall";
import StampDutyCalculator from "../../calculators/StampDutyCalculator";
import CalculatorImage from "../../../assets/images/homepage_01.png";

const StampDutyPage = () => (
  <div>
    <SEO
      title="Stamp Duty Calculator"
      description="Estimate the property transaction tax that may apply when purchasing a property in England, Northern Ireland, Scotland or Wales."
      path="/calculators/stamp-duty"
    />
    <Hero
      title=""
      subtitle=""
      backgroundImage={CalculatorImage}
      titleAlign="left"
      subtitleAlign="left"
      wantOverlay={false}
    >
      <div className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">
            Mortgage Calculators
          </div>
          <h1 className="text-primary-1 text-center">
            How much stamp duty will I pay?
          </h1>
          <div className="content text-primary-2 text-center">
            Before buying, it's important to calculate Stamp Duty fees in
            England, Scotland, and Wales.
          </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>
    <StampDutyCalculator />
  </div>
);

export default StampDutyPage;
